var map = {
	"./air-compressors.svg": "5641",
	"./air-conditioner.svg": "4da1",
	"./bathroom.svg": "970f",
	"./bunk-beds.svg": "d0d1",
	"./dishwasher.svg": "5699",
	"./dressing-room.svg": "42c2",
	"./electricity-outlets.svg": "f5f1",
	"./fireplace.svg": "6b61",
	"./hot-water.svg": "e9de",
	"./king-size-bed.svg": "67cd",
	"./kitchen.svg": "a1e7",
	"./mats.svg": "75a5",
	"./music--icon.svg": "78cd",
	"./palapas.svg": "c929",
	"./parking-lot.svg": "dbff",
	"./projector.svg": "92f9",
	"./sewer-system.svg": "4326",
	"./shower.svg": "ab01",
	"./sink.svg": "3900",
	"./sofa.svg": "e5f6",
	"./steakhouse.svg": "762b",
	"./table.svg": "9f27",
	"./view-to-lake.svg": "8fec",
	"./water.svg": "8d5c",
	"./wifi.svg": "5169"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bcc";